import { Palette } from "../../constants/palettes";
import { ButtonSize, ButtonVariant } from "./types";
export var defaultProps = {
  palette: Palette.Positive,
  size: ButtonSize.Large,
  fullWidth: false,
  hasMinWidth: true,
  helperText: '',
  variant: ButtonVariant.Primary,
  href: null
};